import React from 'react';

import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import { SmallHeading } from '../SmallHeading';

interface ICertificateProps {
  img: string;
  heading: string;
  text: string;
  title?: string;
}
export const Certificate: React.FC<ICertificateProps> = ({ img, heading, text, title }) => (
  <View style={styles.margin} wrap={false}>
    {title && <SmallHeading heading={title} />}
    <View style={styles.wrap}>
      <View style={styles.imageWrap}>{!!img && <Image src={img} style={styles.image} />}</View>
      <View style={styles.line}></View>
      <View style={styles.textWrap}>
        <Text style={styles.heading}>{heading}</Text>
        <Text style={styles.text}>{text}</Text>
      </View>
    </View>
  </View>
);

const styles = StyleSheet.create({
  margin: {
    marginBottom: 30,
  },
  wrap: {
    width: '100%',
    minHeight: '89.6px',
    borderTop: '0.3px dotted #77787C',
    borderBottom: '0.3px dotted #77787C',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#212121',
  },
  imageWrap: {
    width: '100px',
    height: '85px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '5px 0 8px 0',
  },
  image: {
    objectFit: 'cover',
  },
  line: {
    height: '79.36px',
    width: '1px',
    borderLeft: '0.3px dotted #77787C',
  },
  textWrap: {
    width: '100%',
    padding: '11px 5px 12.55px 25.05px',
  },
  heading: {
    fontFamily: 'Noto',
    fontSize: '11px',
    lineHeight: 1.1,
    fontWeight: 300,
    marginBottom: '5px',
  },
  text: {
    fontFamily: 'Noto',
    fontSize: '9px',
    lineHeight: 1.3,
    fontWeight: 300,
  },
});
